import React from 'react'
import { Container } from 'react-bootstrap'
import * as E from './termsAndConditionsElements'
import { formatCurrency } from 'application/helpers'

interface IInputProps {
  isGov: boolean
  displayRetailPrice: boolean
  fbtMethod: string
  payFrequency: string
  financierFeePerPay: number
}

export const TermsAndConditionsRS = ({
  isGov,
  displayRetailPrice,
  fbtMethod,
  payFrequency,
  financierFeePerPay
}: IInputProps) => {

  return (
    <E.TnCParentDiv
      className="terms-conditions print-page-break-before"
      id="termsandconditions"
    >
      <Container>
        <div className="font-weight-bold mb-3">Things you should know</div>
        <div className="text-smaller font-weight-bold mb-2">
          Novated Lease calculator terms and conditions
        </div>
        <div className="text-smaller mb-3">
          <p className="mb-2">
            By using this calculator you agree to our terms and conditions
            below:
          </p>
          <ol>
            <li>
              This calculator provides general information for illustrative
              purposes only by using some generic taxation scenarios and some
              publicly available general material published on the ATO's website{' '}
              <a
                href="https://www.ato.gov.au"
                target="_blank"
                rel="noopener noreferrer"
                className="link"
              >
                www.ato.gov.au
              </a>
              . It does not offer a complete overview of applicable taxation
              methods; This calculator does not use or consider any individual’s
              own financial circumstances at all and may not be accurate for all
              circumstances.
            </li>
            <li>
              Users must not rely on or consider any results generated by the
              calculator as personal taxation advice.
            </li>
            <li>
              RemServ is not licensed to provide taxation advice to anyone.
            </li>
            <li>
              RemServ strongly recommends all users seek their own personal
              taxation advice from a licensed tax adviser before making any
              financial decisions.
            </li>
            <li>
              RemServ provides no warranties as to the accuracy of the estimated
              results produced by the calculator.
            </li>
            <li>
              The car images shown are for illustrative purposes only and may
              not be an exact representation of the car on offer.
            </li>
          </ol>
        </div>
        <div className="text-smaller font-weight-bold mb-2">
          Assumptions, Terms &amp; Conditions
        </div>
        <div className="text-smaller">
          {fbtMethod != undefined && fbtMethod.toLowerCase() === 'ecm' && (
            <div className="mb-3">
              This Proposal is structured using the Employee Contribution Method
              (ECM), based on 20% statutory percentage. ECM is the method of
              salary packaging a motor vehicle lease where you agree to make
              both a pre-tax contribution and a post-tax contribution from your
              salary to your employer. The ECM is equal to the estimated taxable
              value of the motor vehicle determined using the statutory formula
              method. Your pre-tax contribution is equal to the estimated annual
              lease and running costs of the vehicle, less your post-tax
              contribution. GST of 1/11 is payable on the ECM contribution, if
              applicable.
            </div>
          )}
          <div className="mb-3">
            <ol>
              <li>
                The prices, interest rates, calculations and budgets in this
                Proposal are based on information provided and current prices
                when quoted. Comparison interest rates are based on RemServ's
                fair estimate of current applicable interest rates at the time
                when quoted. The prices and rates may vary at the time of
                delivery. The amount financed with RemServ is the amount paid to
                acquire the car to lease it to you. If you purchase the car on
                termination of the lease, GST is payable on the purchase price
                you pay at that time. An indicative annual vehicle management
                service fee of $275.00 (incl. GST) has been included in your
                operating expenses. This fee may vary depending on your
                employer. The amount financed includes a finance establishment
                fee of $475.00 (incl. GST) which is charged by the financier.
                {!isGov && <span> The Vehicle Lease Repayments include a {formatCurrency(financierFeePerPay)} {payFrequency.toLowerCase()} account 
                keeping fee which is charged by the financier.</span>} An
                indicative average administration fee of $325.00 has also been
                included. This fee may vary depending on your employer. Please
                refer to your employer's salary packaging policy for more
                information. A copy of the policy may be obtained from your
                employer or by contacting RemServ on 1300 30 39 40.<br /><br />
                The calculations used to prepare this quote are based on current 
                income tax rates and threshold.
              </li>
              <li>
                The <strong>Novated Lease Fees</strong> are indicative of
                packaging a Novated Lease and do not incorporate the salary
                packaging fees that may be applicable from your salary packaging
                provider.
              </li>
              <li>
                When you enter into a Fully Maintained Novated Lease, you agree
                to lease the vehicle for a fixed period of time. It is important
                you structure the lease over a period that reflects how long you
                wish to keep the vehicle. Otherwise If you decide to terminate
                your novated lease early, depending on the length that has been
                completed, the payout figure may be higher than the current
                market value of the vehicle and includes fees and charges
                imposed by the financer.
              </li>
              <li>
                RemServ provides administration and referral services on behalf
                of employers. RemServ does not provide any form of financial,
                taxation or financial product advice to employees on the
                relative merits of package programs or on any other basis. Some
                information on taxation matters may be provided to illustrate
                possible advantages, but is general information only. We
                strongly recommend you seek independent financial advice before
                making any financial decisions regarding a vehicle lease.
                RemServ may receive commissions or rebates and retain interest
                earned on moneys held in connection with some services it
                provides or arranges to be provided by third parties. We receive 
                a commission from the financier for introducing you to them.
                Tax laws regarding the treatment of salary packaging benefits may change,
                which could adversely impact any financial, taxation or welfare
                benefit decisions. Please contact us for an accurate estimate of
                your annual net benefit, leasing costs and the fees that may be
                applicable to you, or refer to your employer's salary packaging
                policy or employee guide.
              </li>
              <li>
                Our Privacy Policy is available on our website,{' '}
                {isGov ? 'www.remservlease.com.au' : 'remserv.com.au'}. It
                outlines the types of personal information we may collect and
                how we may use and disclose it as well as details on how you can
                seek access or correct personal information that we hold about
                you. Our Privacy Policy also explains how you can make a
                complaint if you think we have breached our obligations to you
                under the Privacy Act 1988. In this instance we intend to use
                your personal information to assist in the delivery of our
                novated leasing services to you and help keep you informed about
                our new products and services. This may involve the disclosure
                of your personal information to our third party providers and
                alliance partners. If you would like to opt out of us disclosing
                your personal information to third party or alliance partners
                and receiving their marketing information you can do so by
                logging into your secure salary packaging account at
                secureremserv.com.au and going to the ‘Change Details’ tab, by
                emailing us at cars@remserv.com.au or giving us a call on 1300
                73 14 29. Please note that, if you elect to opt out, we may not
                be able to provide all our services to you but you will still
                receive reports, important reminders and Transaction Statements
                from us, from time to time. If you provide us with feedback, we
                may use that feedback for marketing purposes, including on our
                website. If we intend to do this, we will notify you, and obtain
                your consent beforehand.
              </li>
              <li>
                Any optional cover from the Motor Vehicle Lease Options policy
                issued by Pacific Insurance Pty Ltd to be included in the
                Novated Lease will be confirmed separately to the acceptance of
                this Proposal and its terms and conditions.
              </li>
            </ol>
          </div>

          {displayRetailPrice && (
            <div>
              <div className="text-smaller font-weight-bold mb-2">
                RemServ Novated Leasing Price and{' '}
                {isGov ? 'Estimated Total ' : 'Recommended '}Retail Price
              </div>
              <div className="text-smaller ml-3">
                <div className="mb-3" style={{ textIndent: '-18px' }}>
                  †&nbsp;&nbsp;The RemServ Novated Leasing Price is the amount
                  we pay to acquire the vehicle to lease it to you. If you
                  purchase the vehicle on termination of the lease, GST is
                  payable on the purchase price you pay at that time. Under a
                  novated lease with RemServ, your lease payments will be
                  calculated based on the RemServ Novated Leasing Price which
                  includes 12 months registration, 12 months compulsory third
                  party insurance (CTP), dealer delivery charge for metropolitan
                  areas, stamp duty, fleet discounts and GST savings. Your lease
                  payments will also take into account the finance cost, the
                  vehicle running costs based on the lease term, kilometres
                  selected and the cost of any additional accessories.
                </div>
                <div className="mb-3" style={{ textIndent: '-18px' }}>
                  ‡&nbsp;&nbsp;{isGov ? 'Estimated Total ' : 'Recommended '}
                  Retail Price includes vehicle list price, delivery charges,
                  dealer accessory prices, on road costs, Goods &amp; Services
                  Tax (GST), GST on fleet discount, aftermarket accessories
                  price (inc. GST) and third party option price (inc. GST).
                </div>
              </div>
            </div>
          )}
        </div>
      </Container>
    </E.TnCParentDiv>
  )
}
